export default __webpack_public_path__ + "static/media/USD.f5827567.png";